import {
  MdQrCode2,
  MdTextFields,
  MdLock,
  MdSwapHoriz,
  MdCurrencyExchange,
} from 'react-icons/md';

export type ToolCategory = 'generator' | 'calculator' | 'general';

export interface FreeTool {
  id: string;
  name: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  path: string;
  color: string;
  category: ToolCategory;
  requiresLogin?: boolean;
}

export const FREE_TOOLS: FreeTool[] = [
  // ——— Generator ———
  {
    id: 'password-generator',
    name: 'Password Generator',
    description: 'Generate secure random passwords',
    icon: MdLock,
    path: '/tools/password-generator',
    color: 'amber',
    category: 'generator',
  },
  {
    id: 'qr-code',
    name: 'QR Code Generator',
    description: 'Generate QR codes for URLs, text, and more',
    icon: MdQrCode2,
    path: '/tools/qr-code',
    color: 'orange',
    category: 'generator',
  },
  // ——— Calculator ———
  {
    id: 'currency-converter',
    name: 'Currency Converter',
    description: 'Convert between currencies with live exchange rates',
    icon: MdCurrencyExchange,
    path: '/tools/currency-converter',
    color: 'slate',
    category: 'calculator',
  },
  // ——— General ———
  {
    id: 'word-counter',
    name: 'Word Counter',
    description: 'Count words, characters, and sentences',
    icon: MdTextFields,
    path: '/tools/word-counter',
    color: 'violet',
    category: 'general',
  },
  {
    id: 'unit-converter',
    name: 'Unit Converter',
    description: 'Convert length, weight, temperature, and more',
    icon: MdSwapHoriz,
    path: '/tools/unit-converter',
    color: 'teal',
    category: 'general',
  },
];

export const CATEGORY_LABELS: Record<ToolCategory, string> = {
  generator: 'Utility Generators',
  calculator: 'Calculators',
  general: 'General',
};

/** Canonical list of tool links for SEO, feature pages, footer, blog. Single source of truth. */
export const FREE_TOOLS_LINKS = FREE_TOOLS.filter((t) => !t.requiresLogin).map((t) => ({
  label: t.name,
  path: t.path,
  description: t.description,
}));

/** HTML string for "Helpful Productivity Tools" section in blog posts. Use in template literals. */
export function getToolsListHtml(): string {
  return FREE_TOOLS_LINKS.map(
    (t) => `<li><a href="${t.path}">${t.label}</a> - ${t.description}</li>`
  ).join('\n      ');
}
